<template>
    <button
        class="text-btn"
        :style="{ '--font-size': fontSize }"
        @click="$emit('click')"
    >{{ text }}</button>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
    props: {
        text: String,
        fontSize: {
            type: String,
            default: '14px'
        }
    }
});
</script>

<style lang="less" scoped>
.text-btn {
    border: none;
    background-color: transparent;
    font-family: @font_02;
    font-size: var(--font-size);
    font-weight: 500;
    line-height: normal;
    letter-spacing: 0em;
    color: @brand_light;
    cursor: pointer;
    padding: 0;

    &:hover {
        color: @brand_light_hover;
    }
}
</style>
